var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecycle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 43,
    height: 43,
    rx: 8,
    fill: "#F0F6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2497 22.9583C13.2497 20.5521 14.2268 18.3646 15.8163 16.775L13.7455 14.7041C11.6455 16.8187 10.333 19.7354 10.333 22.9583C10.333 28.9083 14.7809 33.8083 20.5413 34.5229V31.5771C16.4143 30.8771 13.2497 27.2896 13.2497 22.9583ZM33.6663 22.9583C33.6663 16.5125 28.4455 11.2916 21.9997 11.2916C21.9122 11.2916 21.8247 11.3062 21.7372 11.3062L23.3268 9.71665L21.2705 7.64581L16.1663 12.75L21.2705 17.8541L23.3268 15.7979L21.7518 14.2229C21.8393 14.2229 21.9268 14.2083 21.9997 14.2083C26.8268 14.2083 30.7497 18.1312 30.7497 22.9583C30.7497 27.2896 27.5851 30.8771 23.458 31.5771V34.5229C29.2184 33.8083 33.6663 28.9083 33.6663 22.9583Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecycle);
export default __webpack_public_path__ + "static/media/recycle.da025d6ae0179cfc5446432a0ebacbfa.svg";
export { ForwardRef as ReactComponent };